import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserStore } from 'src/app/shared/services/user/user.state';

export const permissionGuard =
  (
    permissionCheck: (userStore: InstanceType<typeof UserStore>) => boolean,
    redirectPath:
      | string
      | ((
          userStore: InstanceType<typeof UserStore>
        ) => string) = '/crm/contacts'
  ): CanActivateFn =>
  (_route, state) => {
    const userStore = inject(UserStore);
    const router = inject(Router);

    if (!permissionCheck(userStore)) {
      const path =
        typeof redirectPath === 'string'
          ? redirectPath
          : redirectPath(userStore);

      if (path.startsWith('./') || path.startsWith('../')) {
        const parentUrl = state.url.substring(0, state.url.lastIndexOf('/'));
        const resolvedPath = path.startsWith('./')
          ? `${parentUrl}/${path.slice(2)}`
          : `${parentUrl.substring(0, parentUrl.lastIndexOf('/'))}/${path.slice(3)}`;
        router.navigateByUrl(resolvedPath);
      } else {
        router.navigate([path]);
      }

      return false;
    }

    return true;
  };
